export default "__VITE_ASSET__kUbfNSL4__"